import { useMutation } from '@apollo/client';
import {
  AddProductsToCartDocument,
  AddProductsToCartMutation,
  AddProductsToCartMutationVariables,
  CreateEmptyCartDocument,
  CreateEmptyCartMutation,
  CreateEmptyCartMutationVariables,
} from '@storefront/data-commerce';
import { clientAuthless } from '@storefront/lib/apollo/client';

function useAddProductsToCartMutation() {
  const [mutateAddProducts, { data, loading, error }] = useMutation<
    AddProductsToCartMutation,
    AddProductsToCartMutationVariables
  >(AddProductsToCartDocument, { client: clientAuthless });
  return {
    mutateAddProducts,
    data,
    loading,
    error,
  };
}

function useCreateEmptyCartMutation() {
  const [mutateEmptyCart, { data, loading, error }] = useMutation<
    CreateEmptyCartMutation,
    CreateEmptyCartMutationVariables
  >(CreateEmptyCartDocument, { client: clientAuthless });
  return {
    mutateEmptyCart,
    cartId: data?.createEmptyCart,
    loading,
    error,
  };
}

export { useCreateEmptyCartMutation, useAddProductsToCartMutation };
